import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { RetailerForApprovalMutationInput, RetailerForApprovalMutationPayload } from '../../schema';
import { Inject } from '../helpers';
import { UserService } from './userService';
import { retForApprovalMutation } from '../components/Calling/constant';

export class RetailerForApprovalService {
  static instance: RetailerForApprovalService;

  @Inject userService: UserService;

  constructor() {
    if (RetailerForApprovalService.instance) {
      return RetailerForApprovalService.instance;
    } else {
      RetailerForApprovalService.instance = this;
    }
  }

  add(
    data: RetailerForApprovalMutationInput,
    onSuccess: (response) => void,
    onError: (response) => void,
  ) {
    Api.graphql<{ input: RetailerForApprovalMutationInput }, RetailerForApprovalMutationPayload>(
      API_URL,
      {
        input: {
          ...data,
          employeeid: this.userService.user$.getValue().employee.id,
        },
      },
      retForApprovalMutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
